import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';


@Injectable()
export class ManageHeaderService {
  constructor(private http: Http) { }

  GetAllModules(RoleID: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers, params: RoleID });
    return this.http.get('api/Dashboard/GetAllNavMenu?RoleId=' + RoleID, options)
      .map((res: Response) => res.json());
  }

  GetAzureKey() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers});
    return this.http.get('api/Dashboard/GetAllAzureKey', options)
      .map((res: Response) => res.json());
  }
}




// WEBPACK FOOTER //
// ./src/app/Services/ManageHeaderService.ts